<script>
import Notation from '../general/Notation'

export default {
  name: 'EkomiWidget',

  components: {
    Notation
  },

  data () {
    return {
      ekomiLoaded: false
    }
  },

  mounted () {
    // Lazy-load eKomi : charger seulement quand le widget devient visible
    if ('IntersectionObserver' in window) {
      const observer = new IntersectionObserver((entries) => {
        if (entries[0].isIntersecting && !this.ekomiLoaded) {
          this.loadEkomiScript()
          observer.disconnect()
        }
      }, { rootMargin: '200px' }) // Précharger 200px avant d'être visible

      observer.observe(this.$el)
    } else {
      // Fallback pour navigateurs anciens
      this.loadEkomiScript()
    }
  },

  methods: {
    loadEkomiScript () {
      if (this.ekomiLoaded) {
        return
      }
      this.ekomiLoaded = true

      const script = document.createElement('script')
      script.src = 'https://smart-widget-assets.ekomiapps.de/static_resources/widget.js'
      script.onload = () => {
        this.registerEkomiWidget()
      }
      document.head.appendChild(script)
    },

    registerEkomiWidget () {
      const w = window;
      const token = 'sf10670768108fb3ec68c';

      w['_ekomiWidgetsServerUrl'] = "https://widgets.ekomi.com";
      w['_customerId'] = 106707;

      if (w['_language'] === undefined) {
        w['_language'] = new Array();
      }
      w['_language'][token] = 'auto';

      if (typeof w['_ekomiWidgetTokens'] !== 'undefined') {
        w['_ekomiWidgetTokens'][w['_ekomiWidgetTokens'].length] = token;
      } else {
        w['_ekomiWidgetTokens'] = new Array(token);
      }

      if (typeof ekomiWidgetMain !== 'undefined') {
        ekomiWidgetMain('ajax', token);
      }
    }
  }
}
</script>

<template>
  <div class="container mx-auto flex flex-wrap">
    <div class="w-1/3 lg:w-1/4 text-center">
      <icon-insurance-cup class="reinsurance-icon" />
      <div class="reinsurance-title">
        La marque n1
      </div>
      <div class="reinsurance-subtitle">
        De la décoration Mariage
      </div>
    </div>
    <div class="w-1/3  lg:w-1/4 text-center">
      <icon-insurance-secure class="reinsurance-icon" />
      <div class="reinsurance-title">
        Paiement 100%
      </div>
      <div class="reinsurance-subtitle">
        Sécurisé
      </div>
    </div>
    <div class="w-1/3  lg:w-1/4 text-center">
      <icon-insurance-thumb class="reinsurance-icon" />
      <div class="reinsurance-title">
        Service client pro
      </div>
      <div class="reinsurance-subtitle">
        Basé en France
      </div>
    </div>
    <div class="order-first lg:order-none lg:w-1/4 text-center">
      <div class="text-2xl font-funny">
        Guirlande de qualité
      </div>
      <p class="text-xs">
        "Je recommande la télécommande qui permet d ajuster l intensité de l éclairage. C'est un vrai plus."</p>
      <div class="text-xs text-sky_grey mb-2">
        5/5 par Aurélie - le 23/04/2025
      </div>
      <div class="flex justify-center mb-3">
      
        <div id="widget-container" class="ekomi-widget-container ekomi-widget-sf10670768108fb3ec68c"></div>
            <a href="https://www.ekomi.fr/avis-clients-skylanternfr.html" target="_blank">
            <img alt="SkyLantern.fr Reviews with ekomi.fr"
            src="https://smart-widget-assets.ekomiapps.de/resources/ekomi_logo.png"
            style="display: none;" />
            </a>
          <!-- <notation :notation="4.6" :max="5" />
            </div>
            <div class="text-5xl font-funny">
              Noté 4,7/5
            </div>
            <div class="text-xs">
              Par <a href="https://www.ekomi.fr/avis-clients-skylanternfr.html" target="_blank" class="underline">3022 clients</a>-->
        </div>
      </div>
    </div>
  </template>

<style lang="scss" scoped>
  .reinsurance-icon {
    @apply mx-auto;
    width: 50px;
    @screen lg {
      width: 80px;
    }
  }
  .reinsurance-title {
    @apply text-lg font-funny;
    @screen lg {
      @apply text-2xl;
    }
  }
  .reinsurance-subtitle {
    @apply text-xs font-bold;
    @screen lg {
      @apply text-base;
    }
  }
</style>
